// @flow
import React, { Component } from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { scrollToElement } from 'Components/utils/scroll/scrollToElement';

type Props = {
  className?: string,
  hasAutoScroll?: boolean,
  isError?: boolean,
  message?: string,
};

export class FormFeedback extends Component<Props> {
  componentDidMount() {
    if (this.props.hasAutoScroll) {
      scrollToElement('.FormFeedbackBeacon');
    }
  }

  render() {
    const { isError, className, hasAutoScroll, message = '' } = this.props;

    return (
      <div
        className={classnames(
          className,
          'flex items-center font-bold leading-one my-3 text-base',
          `${isError ? 'text-danger' : 'text-success'}`,
          { FormFeedbackBeacon: hasAutoScroll },
        )}
      >
        <Icon
          className={classnames('flex-shrink-0 rtl:mr-3', {
            'pt-1 px-1': !isError,
          })}
          name={isError ? ICONS.WARNING : ICONS.STRAIGHT_CHECK}
          width="1.25rem"
        />
        <span data-testid="FormFeedback-message">{message}</span>
      </div>
    );
  }
}
